<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="rhipe/programs"
        />
    </div>
</template>

<script>
    import Http from '@/helpers/Http';

    export default {
        data() {
            return {
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: null,
                columns: [
                    {
                        title: 'Name',
                        field: 'Program',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Vendor',
                        field: 'Vendor',
                        sorter: 'string',
                        minWidth: 200,
                    },
                ],
                actions: [
                    {
                        label: 'Sync',
                        icon: () => import('@/icons/Sync.vue'),
                        handler: this.sync
                    },
                ],
            }
        },
        methods: {
            sync() {
                this.tableIsLoading = true;
                this.tableLoadingText = 'Syncing...';
                Http.patch('rhipe/programs/sync')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    });
            }
        }
    }
</script>